import { colors, fontSize, inputSubmitStyles } from '../../constants/styleConstants';
import { breakpoints } from './breakpoints';

export const interactiveFilterPanelStyle = () => ({
  // view modes
  interactiveFilterPanel: {
    width: '100%',
    minHeight: 280,
    height: '100%',
  },
  interactiveFilterPanel_compact: {
    width: '100%',
    minHeight: 280,
    height: '100%',

    '& input,& textarea, & select': {
      fontSize: inputSubmitStyles.overrideFontSizeForMobile,
    },

    '& $gridRowItem': {
      width: '100%',
    },
  },
  interactiveFilterPanel_mobile: {
    width: '100%',
    minHeight: 280,
    height: '100%',

    // to fix mobile zooming in safari
    '& input,& textarea, & select': {
      fontSize: inputSubmitStyles.overrideFontSizeForMobile,
    },

    '& $gridRowItem': {
      width: '100%',
    },

    '& $mobileSearch': {
      display: 'flex',
      width: 55,
      height: 'auto',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },

    '& $title': {
      fontSize: '1.5rem',
    },
  },
  form: {
    width: '100%',
  },

  // Layout
  gridContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  gridRow: {
    display: 'flex',
    flex: '1 1 auto',
    flexFlow: 'row wrap',
    margin: '10px 12px 0 12px',
    flexWrap: 'wrap',
  },
  gridRowItem: {
    margin: '10px 5px 5px 5px',
    flexGrow: 1,
  },
  noFlexGrow: {
    flexGrow: 0,
  },

  // Title section
  titleSection: {
    fontFamily: 'Roboto',
    display: 'flex',
    flexFlow: 'row nowrap',
    flexGrow: 1,
  },

  titleGroup: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
  },

  title: {
    color: colors.title,
    fontSize: '2.33rem',
    lineHeight: 1.1,
    margin: 0,
  },

  subtitle: {
    fontFamily: 'Roboto',
    color: colors.grey1,
    fontSize: 12,
  },

  mobileSearch: {
    display: 'none',
  },

  mobileSearch_container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  mobileSearch_row: {
    width: '100%',

    '& $title': {
      fontSize: '1.5rem',
    },
  },

  mobileSearch_search: {
    display: 'flex',
    width: 55,
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexGrow: 1,
  },

  mobileSearch_icon: {
    width: 32,
    height: 32,
    border: `solid 1px ${colors.border.grey1}`,
    backgroundColor: colors.white,
  },
  mobileSearch_icon_absolute: {
    position: 'absolute', // fix for mobile rendering
  },

  closeIcon: {
    background: 'transparent',
    height: 18,
    width: 18,
  },
  // ViewBy Section
  viewByRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  // Dropdown Filter Section
  filterSection: {
    margin: '10px 7px 0 7px',
  },
  dropDownFilter: {},
  musicalWorks: {
    width: 230,
  },

  // Date Filter Section
  dateFilterMobile: {
    '& .DayPickerInput-Overlay ': {
      bottom: '35px', // height of the control},
    },
  },
  // AddDays Filter Section
  noMarginTop: {
    marginTop: 0,
  },
  // Call to Action
  searchAction: {
    width: 98,
    height: 35,
    margin: 0,
    padding: '0',
    borderRadius: 8,
    boxShadow: '0 2px 4px 0 rgba(0, 31, 59, 0.25)',
    backgroundColor: colors.blue3,

    '&:hover': {
      backgroundColor: colors.blue3,
    },

    '&:active': {
      backgroundColor: colors.blue3,
    },

    '&:focus': {
      backgroundColor: colors.blue3,
    },
  },
  clearAllAction: {
    width: 110,
    height: 34,
    margin: '0px 8px 0 0',
    padding: '10px 2px',
    fontSize: fontSize.medium,
    color: colors.clearGray,
    fontWeight: 'bold',

    '&:hover': {
      color: colors.darkBlue,
    },

    '&:active': {
      color: colors.darkBlue,
    },

    '&:focus': {
      color: colors.darkBlue,
    },
  },
  callToActionGroup: {
    marginLeft: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'flex-end',
  },

  // breakpoints
  [breakpoints.xSmall]: {
    viewByRow: {
      flexFlow: 'column wrap',
      width: 'calc(100% - 24px)',
      margin: '10px 12px 0 12px',
    },
    dropDownFilter: {
      width: 'calc(100% - 24px)',
    },
  },
  [breakpoints.small]: {
    dropDownFilter: {
      width: 'calc(100% - 24px)',
    },
    callToActionGroup: {
      width: 'calc(100% - 24px)',
      marginBottom: 20,
    },
    searchAction: {
      margin: 0,
    },
  },
  [breakpoints.medium]: {
    callToActionGroup: {
      width: 'calc(40% - 24px)',
      justifyContent: 'flex-end',
      marginBottom: 20,
    },
  },
});
